import { RootState } from 'store/rootTypes';

export const ContainerSelector = (state: RootState) => state.Container;
